import React from "react";
import { motion } from "framer-motion";
import "./genetic-counselors-hero.css";
import LazyBackground from "../../Lazy/lazy-background";

const GeneticCounselorsHero = () => {
  // Animation variants for consistency
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 100 },
    },
  };

  return (
    <motion.section
      className="gc-hero-section"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <LazyBackground
            src={`${process.env.PUBLIC_URL}/assets/background14.svg`}
            alt=""
            className="home-background home-background2"
            loading="lazy"
          />
          <LazyBackground
            src={`${process.env.PUBLIC_URL}/assets/genetic-stars.png`}
            alt=""
            className="home-background home-star1"
            loading="lazy"
          />
          <LazyBackground
            src={`${process.env.PUBLIC_URL}/assets/genetic-stars.png`}
            alt=""
            className="home-background home-star2"
            loading="lazy"
          />
      <div className="gc-hero-container">
        {/* Top part of the hero */}
        <div className="gc-hero-top">
          <motion.div className="gc-hero-title-area" variants={itemVariants}>
            <span className="gc-hero-label">COUNSELORS</span>
            <h1>Genetic Counselors</h1>
          </motion.div>
          <motion.div className="gc-hero-description" variants={itemVariants}>
            <p>
              Genetic testing can unlock powerful insights about your health —
              but understanding those insights is just as important. That’s
              where our genetic counselors come in.
            </p>
          </motion.div>
        </div>

        {/* Middle part of the hero */}
        <motion.div className="gc-who-are-we" variants={containerVariants}>
          <motion.h2 variants={itemVariants}>Who Are Our Counselors?</motion.h2>
          <motion.p className="gc-who-are-we-subtitle" variants={itemVariants}>
            Our genetic counselors are a diverse group of highly trained
            professionals, including:
          </motion.p>
          <motion.div className="gc-pills-container">
            <motion.div className="gc-info-pill" variants={itemVariants}>
              Medical practitioners with clinical experience
            </motion.div>
            <motion.div className="gc-info-pill" variants={itemVariants}>
              Experts with advanced degrees in medical genetics and related
              fields
            </motion.div>
          </motion.div>
        </motion.div>

        {/* Bottom part of the hero */}
        <motion.div className="gc-hero-summary" variants={itemVariants}>
          <h3>
            They’re not your personal doctors, but they bring together
            scientific expertise and compassionate care to help you and your
            healthcare provider make informed decisions about your health.
          </h3>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default GeneticCounselorsHero;